export const PROJECT_FILTER_NOME_DO_PROJETO = 0;
export const PROJECT_FILTER_NOME_DO_PROFESSOR = 1;
export const PROJECT_FILTER_ASSESSOR_PEDAGOGICO = 2;
export const PROJECT_FILTER_INSTITUICAO = 3;

const allStatus = [];
allStatus[PROJECT_FILTER_NOME_DO_PROJETO] = {
  name: 'Nome do projeto',
};
allStatus[PROJECT_FILTER_NOME_DO_PROFESSOR] = {
  name: 'Professor',
};
allStatus[PROJECT_FILTER_ASSESSOR_PEDAGOGICO] = {
  name: 'Assessor(a) pedagógico(a)',
};
allStatus[PROJECT_FILTER_INSTITUICAO] = {
  name: 'Instituição',
};

function getName(index) {
  if (index < allStatus.length) {
    return allStatus[index].name;
  }
  return null;
}

export { allStatus, getName };
